enum HashLinks {
  AudienceInsights = 'insights',
}

export { HashLinks }
